<template>
    <div name="improvements" class="improvement-list">
        <card4 />
        <card5 style="margin-top: 32px;"/>
        <card1 style="margin-top: 32px;"/>
        <card2 style="margin-top: 32px;" />
        <card3 style="margin-top: 32px;" />
        <div class="end-contents" style="margin-top: 32px;">
            곧 오픈 예정이에요.
        </div>
    </div>
</template>

<script>
import Card1 from '@/components/molecules/pc_uncomfortable/improvements/Card1'
import Card2 from '@/components/molecules/pc_uncomfortable/improvements/Card2'
import Card3 from '@/components/molecules/pc_uncomfortable/improvements/Card3'
import Card4 from '@/components/molecules/pc_uncomfortable/improvements/Card4'
import Card5 from '@/components/molecules/pc_uncomfortable/improvements/Card5'

export default {
    components: { Card1, Card2, Card3, Card4, Card5 },
    name: 'improvementList'
}
</script>

<style scoped>
    .improvement-list { 
        width: 702px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .end-contents {
        display: flex;
        height: 128px;
        width: 100%;
        padding: 32px;
        justify-content: center;
        align-items: center;
        border-radius: 18px;
        border: 1px solid var(--Gray-20, #F3F5F8);
        background: var(--gray-30-stroke, #E8EAEE);
        color: var(--gray-40-button-stroke, #D1D6DB);
        text-align: center;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 120% */
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/pc_uncomfortable/ImprovementList.vue